"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useTimeout(callback, delay) {
    var savedCallback = react_1.useRef();
    react_1.useEffect(function () {
        savedCallback.current = callback;
    }, [callback]);
    react_1.useEffect(function () {
        var tick = function () {
            if (savedCallback.current) {
                savedCallback.current();
            }
        };
        if (delay) {
            var id_1 = setTimeout(tick, delay);
            return function () { return clearTimeout(id_1); };
        }
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return function () { };
    }, [delay]);
}
exports.useTimeout = useTimeout;
function useInterval(callback, delay) {
    var savedCallback = react_1.useRef();
    react_1.useEffect(function () {
        savedCallback.current = callback;
    }, [callback]);
    react_1.useEffect(function () {
        function tick() {
            if (savedCallback.current) {
                savedCallback.current();
            }
        }
        if (delay) {
            var id_2 = setInterval(tick, delay);
            return function () { return clearInterval(id_2); };
        }
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return function () { };
    }, [delay]);
}
exports.useInterval = useInterval;
//# sourceMappingURL=timeUtils.js.map